// extracted by mini-css-extract-plugin
module.exports = {"friendsAndFamilyStyleWrapper":"FriendsAndFamilyView_friendsAndFamilyStyleWrapper__fky2r"};